export default "__VITE_ASSET__BCSNzjs9__"